const ITEMS = [
  "Covelli",
  "Built to Scale",
  "Targeted Ads",
  "Pro Videography",
  "We Sell Results",
  "Coming Q4 2026",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-6 font-display text-4xl font-extrabold uppercase tracking-tight md:px-10 md:text-6xl ${
            i % 2 === 0 ? "text-slate-900" : "text-outline-sky"
          }`}
        >
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-kinetic" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-label="Covelli brand values"
    className="relative overflow-hidden border-y border-slate-200 bg-white py-8 md:py-10"
  >
    <div className="animate-marquee flex w-max">
      <Strip />
      <Strip />
    </div>
  </section>
);
